import {
  testMyHousfyShallowMount,
  myHousfyShallowMount,
} from "@/tests/unit/setup";
import Dashboard from "@/views/Dashboard.vue";
import api from "@/api";
import { Banner } from "@/enums/Banner";
import { BANNER_VALUATION } from "@/constants/Banner";

jest.mock("@/api");

const component = (data = {}) => {
  return myHousfyShallowMount(Dashboard, {
    data,
  });
};

beforeEach(() => {
  jest.restoreAllMocks();
});

describe("Dashboard", () => {
  testMyHousfyShallowMount(Dashboard);

  describe("Mounted", () => {
    it("Should call api to retrieve active user services", () => {
      // given
      spyOn(api.userServices(), "retrieveActiveServices");
      component();
      // when
      // then
      expect(api.userServices().retrieveActiveServices).toHaveBeenCalled();
    });
  });

  describe("Computed", () => {
    describe("servicesCount", () => {
      it("Should return number of active services", () => {
        // given
        const userServices = {
          sellerCount: 0,
          buyerCount: 0,
          rentalsOwnerCount: 0,
          rentalsTenantCount: 0,
          mortgagesCount: 0,
          bannerToShow: Banner.VALUATION,
        };
        spyOn(api.userServices(), "retrieveActiveServices").and.returnValues(
          userServices
        );
        const dashboard = component();
        // when
        // then
        expect(dashboard.vm.servicesCount).toEqual(0);
      });

      it("Should return number of active services", async () => {
        // given
        const userServices = {
          sellerCount: 2,
          buyerCount: 0,
          rentalsOwnerCount: 0,
          rentalsTenantCount: 1,
          mortgagesCount: 0,
          bannerToShow: Banner.VALUATION,
        };
        spyOn(api.userServices(), "retrieveActiveServices").and.returnValue(
          userServices
        );
        const dashboard = await component();
        // when
        // then
        expect(dashboard.vm.servicesCount).toEqual(2);
      });
    });

    it("banner should return which banner to show based on api", async () => {
      // given
      const userServices = {
        sellerCount: 2,
        buyerCount: 0,
        rentalsOwnerCount: 0,
        rentalsTenantCount: 1,
        mortgagesCount: 0,
        bannerToShow: Banner.VALUATION,
      };
      spyOn(api.userServices(), "retrieveActiveServices").and.returnValue(
        userServices
      );
      const dashboard = await component();
      // when
      // then
      expect(dashboard.vm.banner).toEqual(BANNER_VALUATION);
    });
  });
});
